import DeudaCreate from './DeudaCreate'
export {DeudaCreate}
export default DeudaCreate
